'use strict';

var React = require('react');
var _ = require('lodash');
var baseUILibButton = require('./button.js');
module.exports = function (props, context) {
    return React.createElement(baseUILibButton, {
        'automationId': props.automationId,
        'className': 'btn-help btn-header help',
        'onClick': props.onClick
    }, '?');
};


// WEBPACK FOOTER //
// ./~/wix-base-ui/lib/controls/helpButton.rt.js